import { instance, auth } from '@api/index'

const authApi = {
  getAuthUser: () => auth.get('auth-user'),
  signUp: userInfo => instance.post('signup', userInfo),
  login: userInfo => instance.post('login', userInfo),
  logout: () => instance.post('logout'),
}

const userApi = {
  getUserInfo: userId => instance.get(`users/${userId}`),
  postNewProfileImg: imgInfo => instance.post('users/upload-photo', imgInfo),
  putUserName: userName => auth.put('settings/update-user', userName),
  putUserPassword: userPassword =>
    auth.put('settings/update-password', userPassword),
}

const channelApi = {
  getChannelInfo: channelName => instance.get(`channels/${channelName}`),
  getChannelList: () => instance.get('channels'),
}

const postApi = {
  getUserPostList: (userId, params) =>
    instance.get(`posts/author/${userId}`, { params }),
  getChannelPostList: (channelId, params) =>
    instance.get(`posts/channel/${channelId}`, { params }),
  createPost: post => auth.post('posts/create', post),
  readPost: postId => instance.get(`posts/${postId}`),
  updatePost: post => auth.put('posts/update', post),
  deletePost: postId => auth.delete('posts/delete', postId),
  createPostLike: postId => auth.post('likes/create', postId),
  deletePostLike: postId => auth.delete('likes/delete', postId),
  createPostComment: commentInfo => auth.post('comments/create', commentInfo),
  deletePostComment: commentId => auth.delete('comments/delete', commentId),
}

const notificationApi = {
  getNotificationList: () => auth.get('notifications'),
  createNotification: notification =>
    auth.post('notifications/create', notification),
}

const followApi = {
  createFollow: userId => auth.post('follow/create', { userId }),
  deleteFollow: userId => auth.delete('follow/delete', { userId }),
}

const searchApi = {
  searchAsUser: userId => instance.get(`search/users/${userId}`),
  searchAsAll: query => instance.get(`search/all/${query}`),
}

export {
  authApi,
  channelApi,
  userApi,
  postApi,
  notificationApi,
  followApi,
  searchApi,
}
